var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeed125X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 10h28v24H8z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.164 28h-1.797v-8.273c-.672.755-1.448 1.31-2.328 1.664v-1.993c.5-.203 1.018-.566 1.555-1.09A4.221 4.221 0 0 0 11.71 16.5h1.453V28zM14.942 28v-2.195h1.805V28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.986 25.96V28h-6.313c.068-.77.275-1.504.622-2.2.346-.695 1.02-1.607 2.02-2.738.79-.9 1.278-1.51 1.46-1.828.27-.463.406-.93.406-1.398 0-.5-.112-.878-.336-1.133-.224-.255-.518-.383-.883-.383-.796 0-1.226.597-1.289 1.79l-1.789-.22c.11-1.166.434-2.023.973-2.57.54-.547 1.257-.82 2.152-.82.985 0 1.727.32 2.227.96.5.642.75 1.376.75 2.204 0 .469-.064.923-.191 1.363-.128.44-.325.883-.59 1.328-.266.446-.709 1.015-1.328 1.707-.579.652-.944 1.081-1.098 1.29a3.712 3.712 0 0 0-.371.609h3.578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.928 25.055 1.797-.227c.047.5.2.893.46 1.18.261.286.548.43.86.43.37 0 .688-.184.953-.551.266-.367.399-.931.399-1.692 0-.718-.132-1.25-.395-1.593-.263-.344-.597-.516-1.004-.516-.515 0-.979.279-1.39.836l-1.461-.258.922-5.96h4.758v2.054h-3.391l-.29 1.945c.407-.245.819-.367 1.235-.367.74 0 1.367.292 1.883.875.651.745.977 1.727.977 2.945 0 1.005-.278 1.93-.832 2.774-.555.843-1.348 1.265-2.38 1.265-.833 0-1.53-.272-2.09-.816-.56-.544-.896-1.32-1.01-2.324z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.417 28 2.453-4.273-2.351-4.024h2.203l1.203 2.281 1.266-2.28H35.3l-2.305 3.929L35.52 28h-2.211l-1.383-2.57L30.519 28z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed125X);
export default __webpack_public_path__ + "static/media/speed125X.f63246c1d622e25a77e9ac31f2603715.svg";
export { ForwardRef as ReactComponent };